import { render, staticRenderFns } from "./pay-to-vendor.vue?vue&type=template&id=254a631f&"
import script from "./pay-to-vendor.vue?vue&type=script&lang=js&"
export * from "./pay-to-vendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports